module.exports = __webpack_public_path__ + "assets/img/logo.6566e2cc.png";